import { useEvent } from 'react-use';

export interface CustomEvents {
  sls_logout: null;
}

export function useCustomEvent<TEventName extends keyof CustomEvents>(
  event: TEventName,
  handler: (event: CustomEvents[TEventName]) => void,
) {
  return useEvent(event, handler);
}

// ----- Events:

export function dispatchLogoutEvent() {
  return window.dispatchEvent(
    new CustomEvent<CustomEvents['sls_logout']>('sls_logout'),
  );
}
